const countries = () => [
  {
    country_name: "USA",
    currency_code: "USD",
    dialog_title: "The US",
    full_country_name: "United States",
    geo: "US",
    human_country: "US",
    locale: "en-US",
    site_country: "us",
    url: "portal.safyrelabs.com",
  },
  {
    country_name: "Canada",
    currency_code: "CAD",
    dialog_title: "Canada",
    full_country_name: "Canada",
    geo: "CA",
    human_country: "CA",
    locale: "en-CA",
    site_country: "ca",
    url: "portal.safyrelabs.com/ca",
  },
]

export default countries
